import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from './service/msal';
import { PermissionsProvider } from './PermissionsContext';
import AuthenticationHandler from './components/AuthenticationHandler';

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((authResult) => {
    const account = msalInstance.getActiveAccount();

    if (!account && !authResult) {
      msalInstance.loginRedirect().catch(e => {
        console.error("Error during loginRedirect:", e);
      });
    } else if (authResult && authResult.account) {
      msalInstance.setActiveAccount(authResult.account);
    }
  }).catch(err => {
    console.log("Error handling redirect promise:", err);
  });
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Router>
    <MsalProvider instance={msalInstance}>
      <PermissionsProvider>
        <AuthenticationHandler>
          <App />
        </AuthenticationHandler>
      </PermissionsProvider>
    </MsalProvider>
  </Router>
);

reportWebVitals();
